import React from 'react'
import { CiamActiveDirectory } from 'lib-tra-ciam-active-directory-react';
import Spinner from "react-bootstrap/Spinner";  
import KJUR from 'jsrsasign';
import { sessionStart } from '../apollo/RestServices';

let cname = "https://login.appstest.cibercolegios.com";
let apiKey = "4_-h5aQUXLlveqAyDSYoGkyQ";
if (process.env.REACT_APP_ENV === "prod") {
  cname = "https://login.appsprod.cibercolegios.com";
  apiKey = "4_GerVtDXv3HXv7VGBKUvu5w";
} else if (process.env.REACT_APP_ENV === "migracion") {
  cname = "https://login.migracionappsprod.cibercolegios.com";
} 


class SsoSignInForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }
    componentDidMount() {
        
        this.setState({
            loading:true
        })
        
        setTimeout(() => {
            this.setState({
                loading:false
            });
        }, "2000");
    }

    render() {

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const redirectionPath = urlParams.get('returnUrl');
        let title = "Ingreso a Cibercolegios"
        if(!redirectionPath.includes("bridge")){
            title = "Inscripción a Cibercolegios"
        }

        return (<div className="card card-signin my-5 col-sm-6 border-left-0">

            <div className="card-body">
                <h1 className="card-title text-center">{title}</h1>
                <div className="form-signin">
                <center>
                    {this.state.loading?<Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                    </Spinner>:null}
                </center>    
                <CiamActiveDirectory

                    apiKey={apiKey}
                    btnClass='btn btn-lg btn-primary btn-block'
                    contentClass='form-signin'
                    redirectLogin={redirectionPath}
                    btnEditProfile={false}
                    btnRegisterLite={false}
                    cdn={cname}
                    autoopen={true}                    
                    btnRegister={false}
                    loginCallBack={(resp) => {
                        console.log(resp, "Testing")
                        return new Promise((resolve)=>{
                            console.log("Using the promise")
                            const payLoad = {
                                sub: `${resp.data.numeroDocumento}_2`,
                                exp: Math.floor(Date.now() / 1000) + (60 * 60),
                                customer: {
                                documentNumber: resp.data.numeroDocumento,
                                documentType: resp.data.tpIdentificacion,
                                telephoneNumber: "NA",
                                mail: resp.profile.email,
                                timeSession: "60",
                                username: `${resp.data.numeroDocumento}_2`,
                                firstName: resp.profile.firstName,
                                lastName: resp.profile.lastName,
                                uid: resp.UID,
                                uidSignature: resp.UIDSignature,
                                signatureTimestap: resp.signatureTimestamp
                                }
                            }
                            const sHeader = JSON.stringify({ alg: "HS256", typ: "JWT" });
                            const token = KJUR.jws.JWS.sign("HS256", sHeader, payLoad, { utf8:  resp.data.numeroDocumento });
                            sessionStorage.setItem("auth_token", token);
                            sessionStart(token).then(_=>{
                                resolve();
                            });
                        });
                    
                }} />
                    
                </div>
            </div>
        </div>)
    }
}

export default SsoSignInForm;
